<template>
  <div class="t-page">
    <div class="t-container">

      <!-- HEADER -->
      <div class="t-header">
        <h2 class="t-title">
          <b-icon icon="truck" class="mr-2"></b-icon>
          {{ $t("Ta'minotchilar Boshqaruvi") }}
        </h2>
        <div class="t-actions">
          <div class="t-search">
            <b-icon icon="search" class="t-search-icon"></b-icon>
            <input v-model="filter" type="search" placeholder="Nomi yoki telefon..." class="t-search-input">
          </div>

          <!-- Toggle: barchasi (qarz 0 ham ko'rinadi) / faqat qarzdor -->
          <div class="t-show-toggle">
            <button :class="['ts-btn', !onlyWithDebt ? 'active' : '']" @click="setOnlyWithDebt(false)">
              <b-icon icon="grid-3x3-gap-fill"></b-icon> Barchasi
            </button>
            <button :class="['ts-btn', onlyWithDebt ? 'active' : '']" @click="setOnlyWithDebt(true)">
              <b-icon icon="exclamation-circle"></b-icon> Faqat qarzdor
            </button>
          </div>

          <button class="t-btn t-btn-secondary" @click="fetchData">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>
          <button class="t-btn t-btn-primary" @click="$router.push('/malumot/taminotchi/create')">
            <b-icon icon="plus-circle-fill"></b-icon> Yangi qo'shish
          </button>
        </div>
      </div>

      <!-- SUMMARY CARDS -->
      <div class="t-summary">
        <div class="t-card t-c-1">
          <div class="t-card-label">JAMI TA'MINOTCHI</div>
          <div class="t-card-value">{{ filteredRows.length }}</div>
        </div>
        <div class="t-card t-c-2">
          <div class="t-card-label">SO'M QARZ (jami)</div>
          <div class="t-card-value t-debt">
            {{ fmtMoney(totalDebtSom) }} <small>so'm</small>
          </div>
        </div>
        <div class="t-card t-c-3">
          <div class="t-card-label">DOLLAR QARZ (jami)</div>
          <div class="t-card-value t-debt">$ {{ fmtMoney(totalDebtDollar) }}</div>
        </div>
        <div class="t-card t-c-4">
          <div class="t-card-label">QARZ BOR (mijoz soni)</div>
          <div class="t-card-value">{{ withDebtCount }}</div>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="t-table-card">
        <div class="t-table-wrap">
          <table class="t-table">
            <thead>
              <tr>
                <th style="width:50px">#</th>
                <th>Ta'minotchi</th>
                <th>Telefon</th>
                <th>Manzil</th>
                <th class="t-right">SO'M qarz</th>
                <th class="t-right">DOLLAR qarz</th>
                <th class="t-center" style="width:200px">Amallar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in filteredRows" :key="item.id" @dblclick="openHistory(item)">
                <td><span class="t-num">{{ idx + 1 }}</span></td>
                <td class="t-strong">{{ item.name }}</td>
                <td>{{ item.phone_number || '—' }}</td>
                <td class="t-muted">{{ item.address || '—' }}</td>
                <td class="t-right">
                  <span :class="['t-debt-cell', item.debt_som > 0 ? 'red' : (item.debt_som < 0 ? 'green' : 'grey')]">
                    {{ fmtMoney(item.debt_som) }}
                  </span>
                </td>
                <td class="t-right">
                  <span :class="['t-debt-cell', item.debt_dollar > 0 ? 'red' : (item.debt_dollar < 0 ? 'green' : 'grey')]">
                    $ {{ fmtMoney(item.debt_dollar) }}
                  </span>
                </td>
                <td>
                  <div class="t-row-actions">
                    <button class="t-icon-btn t-pay" @click="openPayment(item)" title="To'lov qilish">
                      <b-icon icon="cash-stack"></b-icon>
                    </button>
                    <button class="t-icon-btn t-history" @click="openHistory(item)" title="Tarix">
                      <b-icon icon="clock-history"></b-icon>
                    </button>
                    <button class="t-icon-btn t-edit" @click="$router.push('/malumot/taminotchi/update/' + item.id)" title="Tahrirlash">
                      <b-icon icon="pencil-square"></b-icon>
                    </button>
                    <button class="t-icon-btn t-del" @click="trash(item)" title="O'chirish">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="!loading && filteredRows.length === 0">
                <td colspan="7" class="t-empty">Ta'minotchi topilmadi</td>
              </tr>
              <tr v-if="loading">
                <td colspan="7" class="t-empty">Yuklanmoqda...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ============ TARIX MODALI ============ -->
    <div v-if="showHistory && historyData" class="t-overlay" @click.self="closeHistory">
      <div class="t-history-modal">
        <div class="t-modal-header">
          <div>
            <h3 class="t-modal-title">
              <b-icon icon="building" class="mr-2"></b-icon>
              {{ historyData.kontragent.name }}
            </h3>
            <div class="t-modal-sub">
              <b-icon icon="telephone"></b-icon> {{ historyData.kontragent.phone_number || '—' }}
              <span v-if="historyData.kontragent.address" class="ml-3">
                <b-icon icon="geo-alt"></b-icon> {{ historyData.kontragent.address }}
              </span>
            </div>
          </div>
          <button class="t-close" @click="closeHistory">&times;</button>
        </div>

        <!-- Balans karta -->
        <div class="t-balance-row">
          <div class="t-balance-card som">
            <div class="t-balance-label">SO'M HISOB</div>
            <div class="t-balance-grid">
              <div><small>Yetkazildi:</small><b>{{ fmtMoney(historyData.balance.supply_som) }}</b></div>
              <div><small>To'landi:</small><b class="text-success">{{ fmtMoney(historyData.balance.paid_som) }}</b></div>
              <div><small>QARZ:</small>
                <b :class="historyData.balance.debt_som > 0 ? 'red' : 'green'">
                  {{ fmtMoney(historyData.balance.debt_som) }} so'm
                </b>
              </div>
            </div>
          </div>
          <div class="t-balance-card dollar">
            <div class="t-balance-label">DOLLAR HISOB</div>
            <div class="t-balance-grid">
              <div><small>Yetkazildi:</small><b>$ {{ fmtMoney(historyData.balance.supply_dollar) }}</b></div>
              <div><small>To'landi:</small><b class="text-success">$ {{ fmtMoney(historyData.balance.paid_dollar) }}</b></div>
              <div><small>QARZ:</small>
                <b :class="historyData.balance.debt_dollar > 0 ? 'red' : 'green'">
                  $ {{ fmtMoney(historyData.balance.debt_dollar) }}
                </b>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab nav -->
        <div class="t-tabs">
          <button :class="['t-tab', { active: histTab === 'prixod' }]" @click="histTab = 'prixod'">
            <b-icon icon="box-arrow-in-down"></b-icon>
            Olib kelganlari ({{ historyData.prixods.length }})
          </button>
          <button :class="['t-tab', { active: histTab === 'oplata' }]" @click="histTab = 'oplata'">
            <b-icon icon="cash-stack"></b-icon>
            To'lovlar ({{ historyData.oplatas.length }})
          </button>
        </div>

        <div class="t-tab-body">
          <!-- PRIXODLAR -->
          <div v-if="histTab === 'prixod'">
            <div v-if="historyData.prixods.length === 0" class="t-empty">Prixod yo'q</div>
            <div v-for="p in historyData.prixods" :key="p.id"
                 :class="['t-prixod-block', 'cur-' + prixodCurStatus(p)]">
              <div class="t-prixod-head">
                <div class="t-prixod-info">
                  <span class="t-prixod-num">#{{ p.number || p.id }}</span>
                  <span class="t-muted">{{ fmtDate(p.created_at) }}</span>
                  <span v-if="p.sklad_name" class="t-chip">{{ p.sklad_name }}</span>
                  <!-- Prixod valyutasi: SO'M / DOLLAR / ARALASH -->
                  <span :class="['t-prixod-cur', prixodCurStatus(p)]">
                    <b-icon :icon="prixodCurIcon(p)"></b-icon>
                    {{ prixodCurLabel(p) }}
                  </span>
                </div>
                <div class="t-prixod-totals">
                  <span v-if="p.som_total > 0" class="t-total-pill som">
                    {{ fmtMoney(p.som_total) }} so'm
                  </span>
                  <span v-if="p.dollar_total > 0" class="t-total-pill dollar">
                    $ {{ fmtMoney(p.dollar_total) }}
                  </span>
                </div>
              </div>
              <table class="t-items-table">
                <thead>
                  <tr>
                    <th>Mahsulot</th>
                    <th class="t-center">Soni</th>
                    <th class="t-right">Narxi</th>
                    <th class="t-center">Valyuta</th>
                    <th class="t-right">Summa</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(it, i) in (p.items || [])" :key="i"
                      :class="parseInt(it.item_price_type) === 2 ? 'row-dollar' : 'row-som'">
                    <td>{{ it.product_extra_name || it.product_name || '—' }}</td>
                    <td class="t-center">{{ it.count }}</td>
                    <td class="t-right">
                      {{ fmtMoney(it.kontragent_price) }}
                      <span class="t-cur-suffix">{{ parseInt(it.item_price_type) === 2 ? '$' : "so'm" }}</span>
                    </td>
                    <td class="t-center">
                      <span :class="['t-cur-badge', parseInt(it.item_price_type) === 2 ? 'dollar' : 'som']">
                        <b-icon :icon="parseInt(it.item_price_type) === 2 ? 'currency-dollar' : 'cash'"></b-icon>
                        {{ parseInt(it.item_price_type) === 2 ? 'DOLLAR' : "SO'M" }}
                      </span>
                    </td>
                    <td class="t-right t-strong">
                      {{ fmtMoney(it.kontragent_summa) }}
                      <span class="t-cur-suffix">{{ parseInt(it.item_price_type) === 2 ? '$' : "so'm" }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="p.comment" class="t-prixod-comment">
                <b-icon icon="chat-left-text"></b-icon> {{ p.comment }}
              </div>
            </div>
          </div>

          <!-- OPLATA -->
          <div v-else>
            <div v-if="historyData.oplatas.length === 0" class="t-empty">To'lov yo'q</div>
            <table class="t-oplata-table">
              <thead>
                <tr>
                  <th>Sana</th>
                  <th>#</th>
                  <th>To'lov turlari bo'yicha</th>
                  <th class="t-right">Jami summa</th>
                  <th>Izoh</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="o in historyData.oplatas" :key="o.id">
                  <td>{{ fmtDate(o.datetime) }}</td>
                  <td><span class="t-num">#{{ o.number || o.id }}</span></td>
                  <td>
                    <span v-if="oplataRows(o).length === 0" class="t-muted">—</span>
                    <span
                      v-for="(r, i) in oplataRows(o)"
                      :key="i"
                      class="t-pay-chip"
                      :class="{ dollar: r.pay_type_id === 3 }"
                    >
                      {{ r.pay_type_name }}:
                      <b>{{ r.pay_type_id === 3 ? '$ ' + fmtMoney(r.summa) : fmtMoney(r.summa) }}</b>
                    </span>
                  </td>
                  <td class="t-right t-strong text-success">{{ fmtMoney(o.summa) }}</td>
                  <td class="t-muted small">{{ o.comment || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- ============ TO'LOV MODALI ============ -->
    <div v-if="showPayment && paymentClient" class="t-overlay" @click.self="closePayment">
      <div class="t-pay-modal">
        <div class="t-modal-header">
          <h3 class="t-modal-title">
            <b-icon icon="cash-stack" class="mr-2"></b-icon>
            To'lov: {{ paymentClient.name }}
          </h3>
          <button class="t-close" @click="closePayment">&times;</button>
        </div>

        <div class="t-pay-info-row">
          <div>
            <small>SO'M qarz</small>
            <b :class="paymentClient.debt_som > 0 ? 'red' : 'green'">{{ fmtMoney(paymentClient.debt_som) }} so'm</b>
          </div>
          <div>
            <small>DOLLAR qarz</small>
            <b :class="paymentClient.debt_dollar > 0 ? 'red' : 'green'">$ {{ fmtMoney(paymentClient.debt_dollar) }}</b>
          </div>
        </div>

        <div class="t-pay-body">
          <div class="t-pay-form">
            <div class="t-form-row">
              <label>Sana</label>
              <input type="date" v-model="payForm.date" class="t-input">
            </div>
            <div class="t-form-row">
              <label>Dollar kursi</label>
              <input type="number" v-model.number="payForm.dollar_rate" class="t-input">
            </div>
            <div class="t-form-row" style="grid-column:1/-1">
              <label>Izoh</label>
              <input type="text" v-model="payForm.comment" class="t-input" placeholder="Izoh...">
            </div>
          </div>

          <!-- ============ TO'LOV TURLARI (barchasi avtomatik) ============ -->
          <div class="t-paytypes">
            <div class="t-pt-head">
              <span class="t-pt-title">TO'LOV TURLARI</span>
              <div class="t-pt-quick">
                <button type="button" class="t-pt-q" @click="fillAllDebt">⚡ Butun qarzni</button>
                <button type="button" class="t-pt-q t-pt-q-clear" @click="clearPayAmounts">Tozalash</button>
              </div>
            </div>

            <div v-if="activeDefs.length === 0" class="t-empty">To'lov turlari topilmadi</div>

            <div
              v-for="def in activeDefs"
              :key="def.id"
              class="t-pt-card"
              :class="{ 'filled': payValue(def) > 0, 'dollar': def.dollar }"
            >
              <div class="t-pt-icon" :style="{ background: def.color }">{{ def.icon }}</div>
              <div class="t-pt-meta">
                <div class="t-pt-name">{{ def.label }}</div>
                <div class="t-pt-sub">{{ def.sub }}</div>
              </div>
              <div class="t-pt-input">
                <summa-input :value="payValue(def)" @input="setPayValue(def, $event)" />
                <small v-if="def.dollar && payValue(def) > 0" class="t-pt-hint">
                  ≈ {{ fmtMoney(payValue(def) * payRate) }} so'm
                </small>
              </div>
              <button type="button" class="t-pt-rest" @click="fillRemainder(def)">Qoldiq</button>
            </div>

            <!-- Yig'indi -->
            <div class="t-pt-totals">
              <div class="t-pt-total-row">
                <span>Jami to'lanmoqda:</span>
                <b>{{ fmtMoney(payFormTotal) }} so'm ekv.</b>
              </div>
              <div v-if="payDollarTotal > 0" class="t-pt-total-row t-pt-sub-row">
                <span>shundan dollarda:</span>
                <b class="green">$ {{ fmtMoney(payDollarTotal) }}</b>
              </div>
              <div v-if="extraDollarApplied > 0.0001" class="t-pt-total-row t-pt-sub-row">
                <span>shundan $ {{ fmtMoney(extraDollarApplied) }} — so'mdan dollar qarzga yo'naltirildi</span>
              </div>
              <div class="t-pt-total-row">
                <span>To'lovdan keyin SO'M qarz:</span>
                <b :class="remainSom > 0.01 ? 'red' : 'green'">{{ fmtMoney(remainSom) }} so'm</b>
              </div>
              <div class="t-pt-total-row">
                <span>To'lovdan keyin DOLLAR qarz:</span>
                <b :class="remainDollar > 0.01 ? 'red' : 'green'">$ {{ fmtMoney(remainDollar) }}</b>
              </div>
              <div v-if="overPay > 0.01" class="t-pt-warn">
                ⚠ Qarzdan {{ fmtMoney(overPay) }} so'm ortiqcha to'lanmoqda — avans sifatida yoziladi.
              </div>
            </div>
          </div>
        </div>

        <div class="t-pay-actions">
          <button class="t-btn t-btn-secondary" @click="closePayment">Bekor qilish</button>
          <button class="t-btn t-btn-primary" :disabled="payLoading || payFormTotal <= 0" @click="submitPayment">
            <b-spinner small v-if="payLoading"></b-spinner>
            <span v-else>To'lash ({{ fmtMoney(payFormTotal) }} so'm ekv.)</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';

// Tizimning standart to'lov turlari (id 1-4) — savdo POS bilan bir xil ko'rinish.
// Boshqa (Ma'lumotnoma > To'lov turi da qo'shilgan) turlar avtomatik generatsiya qilinadi.
const SYSTEM_PAY_DEFS = {
  1: { id: 1, label: 'Naqd',    sub: "SO'M", icon: '💵', color: '#dcfce7', dollar: false },
  2: { id: 2, label: 'Plastik', sub: "SO'M", icon: '💳', color: '#dbeafe', dollar: false },
  3: { id: 3, label: 'Dollar',  sub: 'USD',  icon: '💲', color: '#fef9c3', dollar: true },
  4: { id: 4, label: 'Hisob',   sub: "SO'M", icon: '🏦', color: '#fce7f3', dollar: false },
};
const CUSTOM_COLORS = ['#f3e8ff', '#fce7f3', '#cffafe', '#ecfccb', '#fed7aa', '#e0e7ff', '#ffe4e6'];
const CUSTOM_ICONS = ['💼', '🏧', '💰', '🪙', '📲', '🌐', '🎫'];

export default {
  name: 'TaminotchilarIndex',
  data() {
    return {
      filter: '',
      // false = barchasi (qarz 0 ham ko'rinadi, default) | true = faqat qarzdor
      onlyWithDebt: false,
      list: [],
      loading: false,
      paytypes: [],
      // Tarix modal
      showHistory: false,
      historyData: null,
      histTab: 'prixod',
      // To'lov modal
      showPayment: false,
      paymentClient: null,
      payLoading: false,
      payForm: {
        date: new Date().toISOString().slice(0, 10),
        dollar_rate: 12000,
        comment: '',
      },
      // { [pay_type_id]: summa } — har bir to'lov turi bo'yicha kiritilgan summa
      payAmounts: {},
    };
  },
  computed: {
    hasDebt() {
      return (r) =>
        Math.abs(parseFloat(r.debt_som) || 0) > 0.01
        || Math.abs(parseFloat(r.debt_dollar) || 0) > 0.01;
    },
    filteredRows() {
      let arr = this.list;
      // Toggle: faqat qarzdorlar
      if (this.onlyWithDebt) arr = arr.filter(r => this.hasDebt(r));
      // Qidiruv
      if (this.filter && this.filter.length >= 2) {
        const q = this.filter.toLowerCase();
        arr = arr.filter(r =>
          (r.name || '').toLowerCase().includes(q)
          || (r.phone_number && String(r.phone_number).includes(q))
        );
      }
      return arr;
    },
    totalDebtSom() {
      // Faqat ko'rinayotgan qatorlar bo'yicha
      return this.filteredRows.reduce((s, r) => s + (parseFloat(r.debt_som) || 0), 0);
    },
    totalDebtDollar() {
      return this.filteredRows.reduce((s, r) => s + (parseFloat(r.debt_dollar) || 0), 0);
    },
    withDebtCount() {
      return this.list.filter(r =>
        Math.abs(parseFloat(r.debt_som) || 0) > 0.01
        || Math.abs(parseFloat(r.debt_dollar) || 0) > 0.01
      ).length;
    },
    payRate() {
      const r = parseFloat(this.payForm.dollar_rate) || 0;
      return r > 0 ? r : 1;
    },
    // Backend'dan kelgan BARCHA to'lov turlari kartochka sifatida ko'rsatiladi
    // (savdo POS dagi kabi) — qo'lda "qo'shish" kerak emas.
    // Ro'yxat bo'sh bo'lsa — 4 ta standart tur fallback.
    activeDefs() {
      const list = this.paytypes || [];
      if (!list.length) return Object.values(SYSTEM_PAY_DEFS);
      return list.map((pt, idx) => {
        const id = parseInt(pt.id);
        if (SYSTEM_PAY_DEFS[id]) {
          return { ...SYSTEM_PAY_DEFS[id], label: pt.name || SYSTEM_PAY_DEFS[id].label };
        }
        const ci = (idx + 4) % CUSTOM_COLORS.length;
        return {
          id,
          label: pt.name || `Tur #${id}`,
          sub: "SO'M",
          icon: CUSTOM_ICONS[ci % CUSTOM_ICONS.length],
          color: CUSTOM_COLORS[ci],
          dollar: false,
        };
      });
    },
    // Kiritilgan summalardan pay_table qurish (barcha turlar, custom turlar ham)
    payTableRows() {
      return this.activeDefs
        .map(d => ({ pay_type_id: d.id, summa: parseFloat(this.payAmounts[d.id]) || 0 }))
        .filter(r => r.summa > 0);
    },
    // So'mdagi turlar yig'indisi (dollar turidan tashqari)
    paySomTotal() {
      return this.activeDefs.reduce((acc, d) => {
        if (d.dollar) return acc;
        return acc + (parseFloat(this.payAmounts[d.id]) || 0);
      }, 0);
    },
    // Dollardagi turlar yig'indisi ($ da)
    payDollarTotal() {
      return this.activeDefs.reduce((acc, d) => {
        if (!d.dollar) return acc;
        return acc + (parseFloat(this.payAmounts[d.id]) || 0);
      }, 0);
    },
    payFormTotal() {
      return this.paySomTotal + this.payDollarTotal * this.payRate;
    },
    debtSom() {
      return Math.max(0, parseFloat(this.paymentClient && this.paymentClient.debt_som) || 0);
    },
    debtDollar() {
      return Math.max(0, parseFloat(this.paymentClient && this.paymentClient.debt_dollar) || 0);
    },
    // Ikki tomonlama valyuta taqsimoti (backend #add bilan bir xil mantiq):
    // 1) Dollar to'lovi avval DOLLAR qarzni yopadi, ortgani so'mga aylantirilib
    //    so'm qarziga tushadi.
    // 2) Aksincha — so'm to'lovi so'm qarzidan ortib ketsa va hali dollar qarzi
    //    qolgan bo'lsa, ortig'i kursga bo'linib dollar qarzini yopadi.
    dollarApplied() {
      return Math.min(this.payDollarTotal, this.debtDollar);
    },
    somPool() {
      return this.paySomTotal + (this.payDollarTotal - this.dollarApplied) * this.payRate;
    },
    extraDollarApplied() {
      const somExcess = this.somPool - Math.max(0, this.debtSom);
      const remainingDollarDebt = Math.max(0, this.debtDollar - this.dollarApplied);
      if (somExcess > 0.0001 && remainingDollarDebt > 0.0001 && this.payRate > 0) {
        return Math.min(somExcess / this.payRate, remainingDollarDebt);
      }
      return 0;
    },
    somApplied() {
      return this.somPool - this.extraDollarApplied * this.payRate;
    },
    remainSom() {
      return this.debtSom - this.somApplied;
    },
    remainDollar() {
      return this.debtDollar - this.dollarApplied - this.extraDollarApplied;
    },
    overPay() {
      return this.remainSom < 0 ? -this.remainSom : 0;
    },
  },
  mounted() {
    this.fetchData();
    this.loadPaytypes();
    this.fetchDollarRate();
  },
  methods: {
    fmtMoney(v) {
      // O'zbekcha format: minglar bo'shliq, kasr — vergul (12 345 678,90)
      const n = parseFloat(v);
      if (!n || isNaN(n)) return '0';
      // en-US — minglar=,  kasr=.  → so'ng minglar=bo'shliq, kasr=vergul
      return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
        .replace(/,/g, ' ')   // thousands: , → bo'shliq
        .replace('.', ',');   // decimal: . → ,
    },
    // Prixod valyuta holati: 'som' | 'dollar' | 'mixed'
    prixodCurStatus(p) {
      const hasSom = parseFloat(p.som_total) > 0;
      const hasDollar = parseFloat(p.dollar_total) > 0;
      if (hasSom && hasDollar) return 'mixed';
      if (hasDollar) return 'dollar';
      return 'som';
    },
    prixodCurLabel(p) {
      const s = this.prixodCurStatus(p);
      if (s === 'mixed') return 'ARALASH (SO\'M + DOLLAR)';
      if (s === 'dollar') return 'DOLLAR PRIXOD';
      return 'SO\'M PRIXOD';
    },
    prixodCurIcon(p) {
      const s = this.prixodCurStatus(p);
      if (s === 'mixed') return 'shuffle';
      if (s === 'dollar') return 'currency-dollar';
      return 'cash';
    },
    fmtDate(ts) {
      if (!ts) return '—';
      const d = new Date(Number(ts) * 1000);
      return d.toLocaleDateString('ru-RU') + ' ' + d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    },
    // To'lov hujjatining turlari bo'yicha tafsiloti:
    // backend pay_rows (junction — custom turlar ham) bersa o'shani, aks holda legacy ustunlar.
    oplataRows(o) {
      if (Array.isArray(o.pay_rows) && o.pay_rows.length > 0) {
        return o.pay_rows.filter(r => parseFloat(r.summa) > 0);
      }
      const legacy = [
        { pay_type_id: 1, pay_type_name: 'Naqd', summa: parseFloat(o.cash_summa) || 0 },
        { pay_type_id: 2, pay_type_name: 'Plastik', summa: parseFloat(o.plastic_summa) || 0 },
        { pay_type_id: 4, pay_type_name: 'Hisob', summa: parseFloat(o.shot_summa) || 0 },
        { pay_type_id: 3, pay_type_name: 'Dollar', summa: parseFloat(o.dollar_summa) || 0 },
      ];
      return legacy.filter(r => r.summa > 0);
    },
    setOnlyWithDebt(val) {
      this.onlyWithDebt = !!val;
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get('api/v1/kontragent/suppliers-with-debt');
        this.list = (res.data || []).filter(r => !r.is_folder);
      } catch (e) {
        console.error(e);
        this.list = [];
      } finally { this.loading = false; }
    },
    async loadPaytypes() {
      try { const r = await axios.get('api/v1/pay-type'); this.paytypes = r.data || []; } catch (e) {}
    },
    async fetchDollarRate() {
      try {
        const r = await axios.get('api/v1/dollar-exchange-rate/last');
        if (r.data && r.data.rate) this.payForm.dollar_rate = parseFloat(r.data.rate) || 12000;
      } catch (e) {}
    },
    async openHistory(item) {
      this.showHistory = true;
      this.historyData = null;
      this.histTab = 'prixod';
      try {
        const res = await axios.get(`api/v1/kontragent/supplier-history/${item.id}`);
        this.historyData = res.data;
      } catch (e) {
        console.error(e);
        alert("Tarixni yuklashda xato");
        this.closeHistory();
      }
    },
    closeHistory() {
      this.showHistory = false;
      this.historyData = null;
    },
    // ===== To'lov turi kartochkalari =====
    payValue(def) {
      return parseFloat(this.payAmounts[def.id]) || 0;
    },
    setPayValue(def, val) {
      const raw = (val && val.target) ? val.target.value : val;
      let v = parseFloat(raw) || 0;
      if (v < 0) v = 0;
      this.$set(this.payAmounts, def.id, v);
    },
    clearPayAmounts() {
      const amounts = {};
      (this.activeDefs || []).forEach(d => { amounts[d.id] = 0; });
      this.payAmounts = amounts;
    },
    // "Qoldiq" — shu to'lov turiga qolgan qarzni to'ldiradi.
    // Dollar turi — qolgan DOLLAR qarzni ($ da), u tugagan bo'lsa so'm qarzni kursga bo'lib.
    fillRemainder(def) {
      this.$set(this.payAmounts, def.id, 0);
      if (def.dollar) {
        const restDollar = this.remainDollar;
        if (restDollar > 0.0001) {
          this.$set(this.payAmounts, def.id, Math.round(restDollar * 100) / 100);
          return;
        }
        const restSom = this.remainSom;
        const val = restSom > 0 && this.payRate > 0 ? Math.round((restSom / this.payRate) * 100) / 100 : 0;
        this.$set(this.payAmounts, def.id, val);
        return;
      }
      const rest = this.remainSom;
      this.$set(this.payAmounts, def.id, rest > 0 ? Math.round(rest * 100) / 100 : 0);
    },
    // Butun qarz: dollar qarz — dollar turiga, so'm qarz — birinchi so'm turiga (odatda Naqd)
    fillAllDebt() {
      this.clearPayAmounts();
      const dollarDef = this.activeDefs.find(d => d.dollar);
      if (dollarDef && this.debtDollar > 0.0001) {
        this.$set(this.payAmounts, dollarDef.id, Math.round(this.debtDollar * 100) / 100);
      }
      const somDef = this.activeDefs.find(d => !d.dollar);
      if (somDef && this.debtSom > 0.0001) {
        this.$set(this.payAmounts, somDef.id, Math.round(this.debtSom * 100) / 100);
      }
    },

    openPayment(item) {
      this.paymentClient = item;
      this.clearPayAmounts();
      this.payForm.comment = `${item.name} ta'minotchiga to'lov`;
      this.payForm.date = new Date().toISOString().slice(0, 10);
      this.showPayment = true;
    },
    closePayment() {
      this.showPayment = false;
      this.paymentClient = null;
      this.clearPayAmounts();
    },
    async submitPayment() {
      if (!this.paymentClient || this.payFormTotal <= 0) return;
      this.payLoading = true;
      try {
        const sklad_id = parseInt(localStorage.getItem('sklad_id')) || 1;
        // Tanlangan sana + hozirgi vaqt (datetime bazada unique — faqat sana yuborilsa
        // bir kundagi ikkinchi to'lov "Validation error" beradi)
        const now = new Date();
        const [y, m, d] = this.payForm.date.split('-').map(Number);
        const datetime = Math.floor(new Date(y, m - 1, d, now.getHours(), now.getMinutes(), now.getSeconds()).getTime() / 1000);
        const pay_table = this.payTableRows;

        // Legacy ustunlar (cash/plastic/shot/dollar) — pay_table dan hisoblash.
        // Custom turlar (id >= 5) faqat pay_table da qoladi — backend ularni junction'dan o'qiydi.
        let cash = 0, plastic = 0, shot = 0, dollar = 0;
        for (const r of pay_table) {
          const s = parseFloat(r.summa) || 0;
          const id = parseInt(r.pay_type_id);
          if (id === 1) cash += s;
          else if (id === 2) plastic += s;
          else if (id === 3) dollar += s;
          else if (id === 4) shot += s;
        }

        await axios.post('api/v1/kontragent-pay', {
          datetime,
          sklad_id,
          kontragent_id: this.paymentClient.id,
          summa: this.payFormTotal,
          // Validator talab qiladigan maydonlar (qoldiq holati)
          current_total: this.debtSom,
          current_total_dollar: this.debtDollar,
          pay_type_kassa: 1,
          kassa_summa: 0,
          type: false, // chiqim (ta'minotchiga berdik)
          pay_type_id: 1,
          dollar_rate: this.payForm.dollar_rate,
          comment: this.payForm.comment,
          cash_summa: cash,
          plastic_summa: plastic,
          shot_summa: shot,
          dollar_summa: dollar,
          qaytim_som: 0,
          qaytim_dollar: 0,
          pay_table,
        });

        this.closePayment();
        this.fetchData();
      } catch (e) {
        console.error(e);
        const d = e.response && e.response.data;
        let msg = (d && (d.message || d.error)) || e.message;
        const errs = d && (Array.isArray(d.errors) ? d.errors : (d.errors && d.errors.errors));
        if (errs && errs.length) {
          msg += ': ' + errs.map(x => x.param ? `${x.param} — ${x.msg}` : x.msg).join(', ');
        }
        alert("To'lov saqlashda xato: " + msg);
      } finally {
        this.payLoading = false;
      }
    },
    trash(item) {
      if (!confirm(`"${item.name}" ta'minotchini o'chirmoqchimisiz?`)) return;
      axios.delete(`api/v1/kontragent/id/${item.id}`).then(() => this.fetchData());
    }
  }
};
</script>

<style scoped>
.t-page {
  padding: 20px;
  background: #f4f7f9;
  height: calc(100vh - 56px);
  overflow-y: auto;
}
.t-container {
  max-width: 1500px;
  margin: 0 auto;
}

/* HEADER */
.t-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.t-title {
  font-weight: 800;
  font-size: 24px;
  color: #0f172a;
  margin: 0;
  display: flex;
  align-items: center;
}
.t-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.t-search {
  position: relative;
  display: flex;
  align-items: center;
}
.t-search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}
.t-search-input {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 9px 14px 9px 36px;
  border-radius: 12px;
  width: 250px;
  outline: none;
  font-size: 13px;
}
.t-search-input:focus { border-color: #a142f4; box-shadow: 0 0 0 3px rgba(161,66,244,0.1); }

/* Toggle: barchasi vs qarzdorlar */
.t-show-toggle {
  display: inline-flex;
  background: #f1f5f9;
  border-radius: 12px;
  padding: 3px;
  gap: 2px;
}
.ts-btn {
  background: transparent;
  border: none;
  padding: 8px 12px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: 0.2s;
  white-space: nowrap;
}
.ts-btn:hover:not(.active) { background: rgba(255,255,255,0.6); color: #a142f4; }
.ts-btn.active {
  background: white;
  color: #0f172a;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
}

.t-btn {
  border: none;
  padding: 10px 18px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.t-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.t-btn-primary { background: linear-gradient(135deg, #a142f4, #8b2cf5); color: white; }
.t-btn-secondary { background: white; color: #475569; border: 1px solid #e2e8f0; }

/* SUMMARY */
.t-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 18px;
}
.t-card {
  background: white;
  border-radius: 14px;
  padding: 14px 16px;
  border: 1px solid #f1f5f9;
  border-top: 3px solid;
  box-shadow: 0 4px 14px rgba(0,0,0,0.02);
}
.t-c-1 { border-top-color: #a142f4; }
.t-c-2 { border-top-color: #2563eb; }
.t-c-3 { border-top-color: #10b981; }
.t-c-4 { border-top-color: #f59e0b; }
.t-card-label {
  font-size: 10px;
  font-weight: 800;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}
.t-card-value {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}
.t-card-value small { color: #94a3b8; font-weight: 500; font-size: 12px; margin-left: 4px; }
.t-debt { color: #e11d48; }

/* JADVAL */
.t-table-card {
  background: white;
  border-radius: 16px;
  padding: 6px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
}
.t-table-wrap { overflow-x: auto; }
.t-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.t-table th {
  background: #f8fafc;
  padding: 12px 12px;
  text-align: left;
  font-size: 11px;
  color: #64748b;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 2px solid #e2e8f0;
}
.t-table td {
  padding: 12px 12px;
  border-bottom: 1px solid #f1f5f9;
}
.t-table tbody tr:hover { background: #faf8ff; cursor: pointer; }

.t-num {
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
}
.t-strong { font-weight: 700; color: #0f172a; }
.t-muted { color: #94a3b8; }
.t-right { text-align: right; font-variant-numeric: tabular-nums; }
.t-center { text-align: center; }
.t-empty {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
  font-style: italic;
}

.t-debt-cell {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}
.t-debt-cell.red { background: #fee2e2; color: #b91c1c; }
.t-debt-cell.green { background: #dcfce7; color: #16a34a; }
.t-debt-cell.grey { background: #f1f5f9; color: #94a3b8; }

.t-row-actions { display: flex; gap: 6px; justify-content: center; }
.t-icon-btn {
  width: 30px; height: 30px;
  border: none; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; font-size: 13px;
  transition: 0.2s;
}
.t-pay { background: #ecfdf5; color: #16a34a; }
.t-pay:hover { background: #16a34a; color: white; transform: scale(1.1); }
.t-history { background: #eff6ff; color: #2563eb; }
.t-history:hover { background: #2563eb; color: white; transform: scale(1.1); }
.t-edit { background: #fef3c7; color: #d97706; }
.t-edit:hover { background: #d97706; color: white; transform: scale(1.1); }
.t-del { background: #fff1f2; color: #e11d48; }
.t-del:hover { background: #e11d48; color: white; transform: scale(1.1); }

/* MODAL */
.t-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}
.t-history-modal, .t-pay-modal {
  background: white;
  width: 100%;
  max-height: 90vh;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: tpop 0.25s ease-out;
}
.t-history-modal { max-width: 1000px; }
.t-pay-modal { max-width: 620px; }
@keyframes tpop {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.t-modal-header {
  padding: 16px 22px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
}
.t-modal-title {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  display: flex;
  align-items: center;
}
.t-modal-sub {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
}
.t-close {
  width: 34px; height: 34px;
  background: white;
  border: none;
  border-radius: 10px;
  color: #64748b;
  font-size: 24px;
  cursor: pointer;
}
.t-close:hover { background: #fee2e2; color: #e11d48; }

/* Balance row */
.t-balance-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 14px 22px;
}
.t-balance-card {
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid;
}
.t-balance-card.som { background: #f0f9ff; border-color: #bae6fd; }
.t-balance-card.dollar { background: #ecfdf5; border-color: #a7f3d0; }
.t-balance-label {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.t-balance-card.som .t-balance-label { color: #0369a1; }
.t-balance-card.dollar .t-balance-label { color: #047857; }
.t-balance-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  font-size: 12px;
}
.t-balance-grid > div { display: flex; flex-direction: column; }
.t-balance-grid small { color: #94a3b8; font-size: 10px; text-transform: uppercase; margin-bottom: 2px; }
.t-balance-grid b { font-size: 13px; color: #0f172a; }
.red { color: #e11d48 !important; }
.green { color: #16a34a !important; }
.text-success { color: #16a34a; }

/* Tabs */
.t-tabs {
  display: flex;
  gap: 6px;
  padding: 8px 22px 0;
  border-bottom: 1px solid #f1f5f9;
}
.t-tab {
  background: transparent;
  border: none;
  padding: 10px 16px;
  border-radius: 10px 10px 0 0;
  font-weight: 700;
  font-size: 13px;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.t-tab:hover { background: #f8fafc; color: #a142f4; }
.t-tab.active {
  background: white;
  color: #0f172a;
  box-shadow: 0 -2px 0 0 #a142f4 inset;
}

.t-tab-body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 22px 22px;
}

/* Prixod block */
.t-prixod-block {
  background: #f8fafc;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  border-left: 3px solid #2563eb;
}
.t-prixod-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 8px;
}
.t-prixod-info { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.t-prixod-num {
  background: #2563eb;
  color: white;
  padding: 3px 10px;
  border-radius: 8px;
  font-weight: 800;
  font-size: 12px;
}
.t-chip {
  background: #dbeafe;
  color: #2563eb;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}
.t-prixod-totals { display: flex; gap: 6px; }
.t-total-pill {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}
.t-total-pill.som { background: #dbeafe; color: #1e40af; }
.t-total-pill.dollar { background: #d1fae5; color: #065f46; }

.t-items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}
.t-items-table th {
  background: #fafbfc;
  padding: 8px 10px;
  font-size: 10px;
  font-weight: 800;
  color: #64748b;
  text-transform: uppercase;
}
.t-items-table td {
  padding: 7px 10px;
  border-bottom: 1px solid #f8fafc;
}

.t-cur-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.4px;
  border: 1px solid transparent;
}
.t-cur-badge svg { font-size: 12px; }
.t-cur-badge.som {
  background: #dbeafe; color: #1e40af; border-color: #93c5fd;
}
.t-cur-badge.dollar {
  background: #d1fae5; color: #065f46; border-color: #6ee7b7;
}

/* Item satr fon — valyuta bo'yicha ozgina farqlash */
.t-items-table tr.row-som { background: #ffffff; }
.t-items-table tr.row-dollar { background: linear-gradient(90deg, #ecfdf5 0%, #ffffff 100%); }
.t-items-table tr.row-dollar td { border-left: 0; }
.t-items-table tr.row-dollar td:first-child {
  border-left: 3px solid #10b981;
  padding-left: 8px;
}
.t-items-table tr.row-som td:first-child {
  border-left: 3px solid #3b82f6;
  padding-left: 8px;
}

/* Narxi/Summa yonida valyuta suffiksi */
.t-cur-suffix {
  margin-left: 4px;
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
  font-variant-numeric: normal;
}

/* Prixod darajadagi katta valyuta badge */
.t-prixod-cur {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.5px;
  border: 1.5px solid transparent;
  text-transform: uppercase;
}
.t-prixod-cur svg { font-size: 13px; }
.t-prixod-cur.som {
  background: #dbeafe;
  color: #1e40af;
  border-color: #60a5fa;
  box-shadow: 0 2px 6px rgba(96, 165, 250, 0.2);
}
.t-prixod-cur.dollar {
  background: #d1fae5;
  color: #065f46;
  border-color: #34d399;
  box-shadow: 0 2px 6px rgba(52, 211, 153, 0.25);
}
.t-prixod-cur.mixed {
  background: linear-gradient(90deg, #dbeafe 0%, #d1fae5 100%);
  color: #4c1d95;
  border-color: #a78bfa;
  box-shadow: 0 2px 6px rgba(167, 139, 250, 0.25);
}

/* Prixod bloki — chap chiziq rangi valyuta bo'yicha */
.t-prixod-block.cur-som { border-left-color: #2563eb; }
.t-prixod-block.cur-dollar { border-left-color: #10b981; }
.t-prixod-block.cur-mixed {
  border-left: 3px solid;
  border-image: linear-gradient(180deg, #2563eb, #10b981) 1;
}

.t-prixod-comment {
  margin-top: 8px;
  font-size: 11px;
  color: #64748b;
  font-style: italic;
}

/* Oplata table */
.t-oplata-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.t-oplata-table th {
  background: #f8fafc;
  padding: 10px 8px;
  font-size: 10px;
  font-weight: 800;
  color: #64748b;
  text-transform: uppercase;
  border-bottom: 2px solid #e2e8f0;
}
.t-oplata-table td {
  padding: 9px 8px;
  border-bottom: 1px solid #f1f5f9;
}
.t-oplata-table tr:hover { background: #faf8ff; }

/* Pay modal */
.t-pay-info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 14px 22px;
  background: #faf5ff;
}
.t-pay-info-row > div { display: flex; flex-direction: column; gap: 4px; }
.t-pay-info-row small {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.t-pay-info-row b { font-size: 15px; }

.t-pay-body {
  flex: 1;
  overflow-y: auto;
}
.t-pay-form {
  padding: 16px 22px 6px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

/* ===== To'lov turlari (savdo POS uslubi) ===== */
.t-paytypes {
  margin: 6px 22px 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 12px;
}
.t-pt-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 8px;
  flex-wrap: wrap;
}
.t-pt-title {
  font-size: 11px;
  font-weight: 800;
  color: #475569;
  letter-spacing: 0.5px;
}
.t-pt-quick { display: flex; gap: 6px; }
.t-pt-q {
  background: #a142f4;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}
.t-pt-q:hover { background: #8e39d9; }
.t-pt-q-clear { background: #e2e8f0; color: #475569; }
.t-pt-q-clear:hover { background: #cbd5e1; }

.t-pt-card {
  display: grid;
  grid-template-columns: 38px minmax(90px, 1fr) minmax(120px, 1.2fr) 64px;
  gap: 8px;
  align-items: center;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 10px;
  margin-bottom: 8px;
}
.t-pt-card.filled { border-color: #a142f4; box-shadow: 0 0 0 3px rgba(161,66,244,0.08); }
.t-pt-card.dollar.filled { border-color: #10b981; box-shadow: 0 0 0 3px rgba(16,185,129,0.1); }
.t-pt-icon {
  width: 34px; height: 34px;
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px;
}
.t-pt-name { font-size: 13px; font-weight: 700; color: #0f172a; }
.t-pt-sub {
  font-size: 10px; font-weight: 700; color: #94a3b8;
  text-transform: uppercase; letter-spacing: 0.4px;
}
.t-pt-input ::v-deep input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 7px 10px;
  font-weight: 700;
  text-align: right;
  outline: none;
}
.t-pt-input ::v-deep input:focus { border-color: #a142f4; background: white; }
.t-pt-hint {
  display: block;
  font-size: 10px;
  color: #16a34a;
  font-weight: 600;
  text-align: right;
  margin-top: 2px;
}
.t-pt-rest {
  background: #f1f5f9;
  border: none;
  border-radius: 8px;
  padding: 7px 6px;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
}
.t-pt-rest:hover { background: #a142f4; color: white; }

.t-pt-totals {
  border-top: 1px dashed #e2e8f0;
  margin-top: 10px;
  padding-top: 10px;
}
.t-pt-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  margin-bottom: 4px;
}
.t-pt-total-row b { font-size: 13px; color: #0f172a; }
.t-pt-sub-row { font-size: 11px; }
.t-pt-warn {
  margin-top: 6px;
  background: #fff7ed;
  color: #c2410c;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 700;
}

.t-pay-chip {
  display: inline-block;
  background: #f1f5f9;
  color: #475569;
  border-radius: 999px;
  padding: 2px 9px;
  font-size: 11px;
  font-weight: 600;
  margin: 2px 4px 2px 0;
}
.t-pay-chip.dollar { background: #d1fae5; color: #065f46; }
.t-form-row { display: flex; flex-direction: column; gap: 5px; }
.t-form-row label {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.t-input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 9px 12px;
  font-weight: 600;
  outline: none;
}
.t-input:focus { border-color: #a142f4; background: white; }

.t-pay-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 14px 22px 18px;
  border-top: 1px solid #f1f5f9;
}

@media (max-width: 900px) {
  .t-summary { grid-template-columns: repeat(2, 1fr); }
  .t-balance-row { grid-template-columns: 1fr; }
  .t-pay-form { grid-template-columns: 1fr; }
}
</style>
